import React, { useEffect, useState } from "react";
import moment from "moment";
import { getDocs,collection,orderBy,limit,query } from "firebase/firestore";

import { stringReducer } from "../../common/helperFunctions";
import { EventCard } from "../../common/EventCard";
import { navigate } from "hookrouter";
import { db } from "../../Firebase/config";

const SkeletonLoader =()=>{
  return <div className="flex flex-wrap w-full">
    <div className="mx-auto  flex flex-wrap w-full justify-center max-w-6xl">
      {[...Array(3)].map(() => (
        <div className="rounded-xl mx-auto mb-2  flex flex-col border w-full max-w-xs animate-pulse">
          <div className=" bg-gray-200 mb-2 h-56  rounded-t-xl"></div>
          <div className=" bg-gray-200 mb-2 mx-3 h-2 rounded-full"></div>
        </div>
      ))}
    </div>
  </div>
}

export default function LatestEvents() {

  useEffect(() => {
    fetchEvents()
  }, [])

  const [events, setEvents] = useState([])
  const [loader, setLoader] = useState(true)
 
  async function fetchEvents(){
    setLoader(true)
    const docRef = collection(db, "events");
    const docSnap = await getDocs(query(docRef,orderBy("Date","desc"),limit(6)));
    let events=[]
    docSnap.forEach(doc=>{
      events.push({id: doc.id, ...doc.data()});
    })
    // achievements.sort((a,b)=>new Date(b.Date)-new Date(a.Date))
    setEvents(events)
    setLoader(false)
  }
  return (
    <div className="w-full bg-white pt-20 text-black">
      <div className=" w-full mx-auto">
        <div className="w-full  justify-center">
          <h1 className="text-3xl text-black text-center mx-auto mb-1 font-bold">
            Latest Events
          </h1>
          <div className=" flex w-full mb-8">
            <div className="flex mx-auto">
              <div className=" w-6 h-4 mr-1  rounded-full bg-blue-600"></div>
              <div className=" w-6 h-4 rounded-full  bg-green-700"></div>
            </div>
          </div>
        </div>
        {!loader?
          <div className="flex w-full">
            <div className="flex max-w-7xl w-full flex-wrap  mx-auto">
              <div className="flex justify-center mx-auto w-full flex-wrap">
                {events?.map((el, i) => {
                  const title = stringReducer(el?.Title, 3);
                  const date = moment(new Date(el?.Date), "LL", true);
                  const day = date
                    ?.format("ll")
                    .replace(",", "")
                    .split(" ");
                  const time = date?.format("LT");
                  return (
                    <EventCard
                      key={i}
                      data={el}
                      day={day}
                      time={time}
                      title={title}
                    />
                  );
                })}
                <div className="w-full flex">
                  <div class="mx-auto relative bg-blue-700 px-2 py-1 rounded-full">
                    <button
                      onClick={() => navigate("/allEvents")}
                      class="text-white focus:outline-none text-sm font-medium "
                    >
                      See All Events
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        :
          <SkeletonLoader/>
        }
      </div>
    </div>
  );
}
